import { createAsyncThunk } from "@reduxjs/toolkit";

import { updateBillingAlertRequest } from "Api/organizations/billingAlert/updateBillingAlert.request";
import { getNewBillingSystemError } from "Hooks/billingSystem/getNewBillingSystemError";
import logger from "Libs/logger";
import { organizationByDescriptionIdSelector } from "Reducers/organization/organization";

import type { BillingAlert } from "../";
import type { AsyncThunkOptionType } from "Reducers/types";

export const updateBillingAlert = createAsyncThunk<
  BillingAlert,
  { organizationId: string; threshold?: number; active: boolean },
  AsyncThunkOptionType
>(
  "app/organization/update_billing_alert",
  async (
    { organizationId, threshold, active },
    { rejectWithValue, getState }
  ) => {
    try {
      const organization = organizationByDescriptionIdSelector(getState(), {
        organizationDescriptionId: organizationId
      });

      if (!organization) {
        return rejectWithValue("Organization does not exist");
      }

      const billingAlert = await updateBillingAlertRequest(organization.id, {
        threshold,
        active
      });

      return billingAlert;
    } catch (err: unknown) {
      logger(err, {
        action: "update_billing_alert",
        organizationId
      });

      return rejectWithValue(
        getNewBillingSystemError(err) ?? "An error has occurred"
      );
    }
  }
);
